export enum OrderTypeEnum {
    ONE = 'enums.orderType.directRental',
    TWO = 'enums.orderType.bookedRental',
    THREE = 'enums.orderType.longtermRental'
}
